import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../../core/authentication/auth.guard';
import { AddMediaComponent } from './add-media/add-media.component';
import { AddTitleComponent } from './add-title/add-title.component';
import { CampaignSummaryComponent } from './campaign-summary/campaign-summary.component';
import { ChannelsLocationComponent } from './channels-location/channels-location.component';
import { CompletePaymentComponent } from './complete-payment/complete-payment.component';
import { MediaPlanOverviewComponent } from './media-plan-overview/media-plan-overview.component';
import { MediasOverviewComponent } from './medias-overview/medias-overview.component';
import { NewCampaignComponent } from './new-campaign.component';
import { ProductScheduleComponent } from './product-schedule/product-schedule.component';
import { CanDeactivateGuard } from './guards/can-deactivate.guard';

const routes: Routes = [
    {
        path: '',
        component: NewCampaignComponent,
        canActivate: [AuthGuard],
        children: [
            {
                path: '',
                redirectTo: 'step-1/',
                pathMatch: 'full'
            },
            {
                path: 'step-1/:id',
                component: AddTitleComponent,
                canDeactivate: [CanDeactivateGuard]
            },
            {
                path: 'step-2/:id',
                component: ChannelsLocationComponent,
                canDeactivate: [CanDeactivateGuard]
            },
            {
                path: 'step-3/:id',
                component: ProductScheduleComponent,
                canDeactivate: [CanDeactivateGuard]
            },
            {
                path: 'step-4/:id',
                children: [
                    {
                        path: '',
                        component: AddMediaComponent,
                        canDeactivate: [CanDeactivateGuard]
                    },
                    {
                        path: 'medias-overview',
                        component: MediasOverviewComponent
                    }
                ]
            },
            {
                path: 'step-5/:id',
                children: [
                    {
                        path: '',
                        component: CampaignSummaryComponent,
                        canDeactivate: [CanDeactivateGuard]
                    },
                    {
                        path: 'media-plan-overview',
                        component: MediaPlanOverviewComponent
                    }
                ]
            },
            {
                path: 'complete-payment/:id',
                component: CompletePaymentComponent,
                canDeactivate: [CanDeactivateGuard]
            }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class NewCampaignRoutingModule {}
